(function () {

    // Bootstrap scripts
    const Bs = require("../_includes/bs.js");
    document.addEventListener("DOMContentLoaded", () => {
        let bs = new Bs();
        bs.runAll();
    });

    document.addEventListener('DOMContentLoaded', function (e) {
        document.querySelectorAll('.larativo-form-birthday').forEach(item => {
            item.addEventListener('keydown', (event) => {
                var charCode = (event.which) ? event.which : event.keyCode
                if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
                    var dateBox = event.target;
                    var chars = dateBox.value.length;
                    var text = dateBox.value;

                    if (chars == 2) {
                        dateBox.value = text + ".";
                    }
                    if (chars == 5) {
                        dateBox.value = text + ".";
                    }
                }
                else if (charCode == 37 || charCode == 39 || charCode == 46 || charCode == 8) { }
                else {
                    event.preventDefault();
                }
            })
        });
    });
})();

const sidebarWidth = 300;

class Sidebar {

    constructor(config) {

        let configDefault = {
            'opened': true,
            'overlay': 'larativo-main-overlay',
            'space': 40,
        };

        config = { ...configDefault, ...config }

        for (let prop in config) {
            if (config.hasOwnProperty(prop)) {
                // console.log("o." + prop + " = " + config[prop]);
                this[prop] = config[prop];
            }
        }
    }

    px(integer) {
        return integer + 'px';
    }

    setWidth(width) {
        this.elem.style['min-width'] = this.px(width);
        this.elem.style['max-width'] = this.px(width);
    }

    toggle() {
        if (this.opened) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        if (window.innerWidth <= this.width + this.space) {
            console.log(this.px(window.innerWidth - this.space));
            this.elem.style.width = this.px(window.innerWidth - this.space);
            this.setWidth(window.innerWidth - this.space);
        } else {
            this.setWidth(this.width);
        }
        this.opened = true;

        if (window.innerWidth < 992) {
            this.addMainOverlay();
        }
    }

    close() {
        this.setWidth(0);
        this.opened = false;
        this.removeMainOverlay();
    }

    resize() {
        let width = window.innerWidth;
        let height = window.innerHeight;

        if (width < 992 && this.opened) {
            this.close();
        }
        if (width >= 992 && !this.opened) {
            this.open();
        }
    }

    getOverlay() {
        return this.main.getElementsByClassName(this.overlay)[0];
    }

    addMainOverlay() {

        let overlay = this.getOverlay();

        if (typeof overlay == "undefined") {
            let div = document.createElement("div");
            div.classList.add(this.overlay);
            div.addEventListener('click', event => {
                this.close();
            })
            this.main.prepend(div);
            overlay = this.getOverlay();
        }
    }

    removeMainOverlay() {
        let overlay = this.getOverlay();
        if (typeof overlay != "undefined") {
            overlay.remove();
        }
    }
}

document.addEventListener('DOMContentLoaded', event => {

    const sidebar = new Sidebar({
        'elem': document.getElementById('sidebar'),
        'width': sidebarWidth,
        'main': document.getElementById('main')
    });

    sidebar.resize()

    document.querySelectorAll('.larativo-sidebar-toggle').forEach(item => {
        item.addEventListener('click', event => {
            sidebar.toggle();
        })
    });

    window.addEventListener('resize', event => {
        sidebar.resize();
    }, true);
});